"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  height: 14px;\n  margin: 0 12px;\n  cursor: pointer;\n  ", ";\n  \n  html.non-touch &:hover {\n    opacity: 0.8;\n  }\n"], ["\n  height: 14px;\n  margin: 0 12px;\n  cursor: pointer;\n  ", ";\n  \n  html.non-touch &:hover {\n    opacity: 0.8;\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "Caret__Container",
  componentId: "sc-1gyhldp-0"
})(_templateObject, function (props) {
  return props.back ? "transform: rotate(180deg);" : "margin-left: 6px;";
});

var Caret = function Caret(props) {
  return _react2.default.createElement(
    Container,
    props,
    _react2.default.createElement(
      "svg",
      { width: "8px", height: "13px", viewBox: "0 0 8 13" },
      _react2.default.createElement(
        "g",
        {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        },
        _react2.default.createElement(
          "g",
          {
            transform: "translate(-1101.000000, -124.000000)",
            stroke: "#B4B4B6"
          },
          _react2.default.createElement("polyline", {
            transform: "translate(1105.000000, 130.000000) rotate(-90.000000) translate(-1105.000000, -130.000000) ",
            points: "1111 127 1104.99956 133 1099 127"
          })
        )
      )
    )
  );
};

exports.default = Caret;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-pagination/dist/images/Caret.js
// module id = 432
// module chunks = 168707334958949